import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _OpenIdConnectLoader;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import OpenIdConnectService from 'core/services/open-id-connect';
import { service } from '@ember/service';
import SemeiaSessionService from 'core/services/session';
import { task } from 'ember-concurrency';
import emberSwal from 'ui-kit/utils/ember-swal';
import { modifier } from 'ember-modifier';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let OpenIdConnectLoader = (_dec = service('browser/window'), _class = (_OpenIdConnectLoader = class OpenIdConnectLoader extends Component {
  constructor(owner1, args1) {
    super(owner1, args1);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "requestManager", _descriptor2, this);
    _initializerDefineProperty(this, "router", _descriptor3, this);
    _initializerDefineProperty(this, "window", _descriptor4, this);
    _defineProperty(this, "authenticator", 'authenticator:open-id-connect');
    // For testing purposes, I need to watch for authorizationCode changes
    _defineProperty(this, "callLoginTask", modifier(() => {
      if (!this.session.medic) {
        this.loginTask.perform();
      }
    }));
    _defineProperty(this, "loginTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          if (!this.args.authorizationCode) {
            const body1 = JSON.stringify({
              auth: {
                issuer: this.args.openIdConnectService.issuer
              }
            });
            const {
              content: content1
            } = yield this.requestManager.request({
              url: '/api/v1/medic_login/sso-login-url',
              method: 'POST',
              body: body1
            });
            this.window.location.replace(content1.url);
          } else {
            yield this.session.authenticate(this.authenticator, {
              issuer: this.args.openIdConnectService.issuer,
              authorizationCode: this.args.authorizationCode
            });
          }
        } catch (error1) {
          const {
            reason: reason1
          } = error1;
          if (reason1) {
            switch (reason1.status) {
              case 401:
                emberSwal.fire('Oops !', `Impossible de vous connecter via ${this.authMethodName}. Vous n'êtes pas autorisé.`, 'error');
                break;
              case 404:
                emberSwal.fire('Oops !', "Vous n'êtes pas encore enregistré chez Sêmeia. Veuillez contacter nos services pour vous inscrire", 'error');
                break;
              default:
                emberSwal.fire('Oops !', `Impossible de vous connecter via ${this.authMethodName}. Veuillez rééssayer.`, 'error');
            }
            console.error(`${this.authMethodName} error :`, reason1);
            this.router.transitionTo('login');
          } else {
            throw error1;
          }
        }
      }
    }), null, "loginTask", null));
    if (!args1.openIdConnectService) {
      throw 'No openIdConnectService provided';
    }
  }
  get authMethodName() {
    return this.args.openIdConnectService.label;
  }
}, setComponentTemplate(precompileTemplate("\n    <div class=\"ui active loader inline w-full\" {{this.callLoginTask @authorizationCode}}></div>\n  ", {
  strictMode: true
}), _OpenIdConnectLoader), _OpenIdConnectLoader), _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "requestManager", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "window", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { OpenIdConnectLoader as default };